module.exports = __webpack_public_path__ + "static/img/applyFail.03ee767f.png";